import { useEffect, useState } from "react";
import "./FilterProducts.scss";
import { getCondition } from "../../services/headersProducts/headersProducts";
import { FaChevronDown } from "react-icons/fa6";
import { Select } from "antd";
import { addUnique } from "../../helper/checkUnique";

function FilterProducts({
  headersProducts,
  paramsFilterUser,
  setParamsFilterUser,
}) {
  const [brands, setBrands] = useState([]);
  const [size, setSize] = useState([]);
  const [color, setColor] = useState([]);
  const [condition, setCondition] = useState([]);
  const [iconRotate, setIconRotate] = useState("");

  useEffect(() => {
    const fetchApi = async () => {
      let contentBrands = [];
      let contentSize = [];
      let contentColor = [];
      let contentCondition = await getCondition();

      if (headersProducts.length === 0) return;

      headersProducts[0].products.forEach((item) => {
        addUnique(contentBrands, item.name);
        addUnique(contentSize, item.size);
        addUnique(contentColor, item.color);
      });

      contentBrands = contentBrands.map((name) => ({
        value: name,
        label: name,
      }));

      contentSize = contentSize.map((size) => ({ value: size, label: size }));

      contentColor = contentColor.map((color) => ({
        value: color,
        label: color,
      }));

      contentCondition = contentCondition.map((item) => ({
        value: item.name,
        label: item.name,
      }));

      setBrands(contentBrands);
      setSize(contentSize);
      setColor(contentColor);
      setCondition(contentCondition);
    };
    fetchApi();
  }, [headersProducts]);

  return (
    <div className="filter-products">
      <div className="filter-products-left">
        {/* Brand */}
        <div className="filter-products-left-item">
          <Select
            allowClear
            style={{ width: 170 }}
            options={brands}
            onChange={(value) =>
              setParamsFilterUser((prev) => ({ ...prev, name: value || "" }))
            }
            placeholder="Thương hiệu"
            suffixIcon={
              <FaChevronDown
                className={`icon-fachev ${
                  iconRotate === "brands" ? "rotate" : ""
                }`}
              />
            }
            onClick={() => setIconRotate("brands")}
            onFocus={() => setIconRotate("brands")}
            onBlur={() => setIconRotate("")}
          />
        </div>

        {/* Size */}
        <div className="filter-products-left-item">
          <Select
            allowClear
            style={{ width: 70 }}
            options={size}
            onChange={(value) =>
              setParamsFilterUser((prev) => ({ ...prev, size: value || "" }))
            }
            placeholder="Size"
            suffixIcon={
              <FaChevronDown
                className={`icon-fachev ${
                  iconRotate === "size" ? "rotate" : ""
                }`}
              />
            }
            onClick={() => setIconRotate("size")}
            onFocus={() => setIconRotate("size")}
            onBlur={() => setIconRotate("")}
          />
        </div>

        {/* Color */}
        <div className="filter-products-left-item">
          <Select
            allowClear
            style={{ width: 120 }}
            options={color}
            onChange={(value) =>
              setParamsFilterUser((prev) => ({ ...prev, color: value || "" }))
            }
            placeholder="Màu sắc"
          />
        </div>

        {/* Condition */}
        <div className="filter-products-left-item">
          <Select
            allowClear
            style={{ width: 200 }}
            options={condition}
            onChange={(value) =>
              setParamsFilterUser((prev) => ({
                ...prev,
                condition: value || "",
              }))
            }
            placeholder="Tình trạng"
            suffixIcon={
              <FaChevronDown
                className={`icon-fachev ${
                  iconRotate === "condition" ? "rotate" : ""
                }`}
              />
            }
            onClick={() => setIconRotate("condition")}
            onFocus={() => setIconRotate("condition")}
            onBlur={() => setIconRotate("")}
          />
        </div>
      </div>

      {/* Sort */}
      <div className="filter-products-right">
        <Select
          allowClear
          style={{ width: 170 }}
          placeholder="Sắp xếp"
          options={[
            { value: "cao-den-thap", label: "Giá: Cao đến Thấp" },
            { value: "thap-den-cao", label: "Giá: Thấp đến Cao" },
          ]}
          onChange={(value) =>
            setParamsFilterUser((prev) => ({ ...prev, priceSort: value || "" }))
          }
        />
      </div>
    </div>
  );
}

export default FilterProducts;
